/* eslint-disable import/prefer-default-export */
export const MIXPANEL_EVENTS = {
  user_logs_in_to_account: 'login-user-logs-in',
  quick_sign_up_create_respondent: 'quick-sign-up_create_respondent',
  quick_sign_up_error_invalid_key: 'quick-sign-up_error_invalid_key',
};
